/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddValveToManifoldRequest {
  /** @format uuid */
  linkedPartId: string;
  /** @format int32 */
  manifoldGroupId: number;
  name: string;
}

export interface AddValveToManifoldResponse {
  valve: Part;
  link: OverlapGroupLinkResponse;
  virtualGroup: VirtualGroup;
}

export enum AggregateFunction {
  Sum = 'Sum',
  Product = 'Product',
  Min = 'Min',
  Max = 'Max',
  Average = 'Average',
  TotalGroups = 'TotalGroups',
  None = 'None',
  Last = 'Last',
  First = 'First',
  Distinct = 'Distinct',
}

export interface CalculatedValue {
  name?: string | null;
  value?: string | null;
  units?: string | null;
  isNumber?: boolean;
}

export enum ChipState {
  Invisible = 'Invisible',
  ReadyToAdd = 'ReadyToAdd',
  ReadyToAddDisabled = 'ReadyToAddDisabled',
  Populated = 'Populated',
  PopulatedDisabled = 'PopulatedDisabled',
}

export enum CompareDisplayMode {
  DataOnly = 'DataOnly',
  Hidden = 'Hidden',
  Always = 'Always',
  AlwaysCantHide = 'AlwaysCantHide',
  Optional = 'Optional',
}

export interface ComparisonAttribute {
  /** @format double */
  valueNumber?: number;
  valueString?: string | null;
  /** @format int32 */
  unit?: number;
  dataSort?: string | null;
}

export enum ComparisonAttributeDisplayType {
  NumberInt = 'NumberInt',
  DecimalifSmall = 'DecimalifSmall',
  NumberIntifLarge = 'NumberIntifLarge',
  NumberPrec2 = 'NumberPrec2',
  NumberPrec3 = 'NumberPrec3',
  NumberPrec3Limit20K = 'NumberPrec3Limit20K',
  NumberFixed2 = 'NumberFixed2',
  NumberFixed3 = 'NumberFixed3',
  NumberPercent = 'NumberPercent',
  NumberPercentColor = 'NumberPercentColor',
  String = 'String',
  DollarSignPrice = 'DollarSignPrice',
  DollarPrice = 'DollarPrice',
  DisplayValue = 'DisplayValue',
  LeadData = 'LeadData',
  TravelData = 'TravelData',
  PDNCycles = 'PDNCycles',
  PDNManifoldLog = 'PDNManifoldLog',
}

export interface ComparisonAttributeHeaders {
  originalKeyName?: string | null;
  displayType?: ComparisonAttributeDisplayType;
  /** @format int32 */
  columnNumber?: number;
  longName?: string | null;
  shortName?: string | null;
  displayOnCompareScreen?: CompareDisplayMode;
  units?: string | null;
  /** @format int32 */
  selectedUnit?: number;
  /** @format int32 */
  minWidth?: number;
  /** @format int32 */
  maxWidth?: number;
}

export interface ComparisonProduct {
  /** @format int32 */
  index?: number;
  title?: string | null;
  productName?: string | null;
  description?: string | null;
  /** @format int32 */
  seriesId?: number;
  seriesName?: string | null;
  partNumber?: string | null;
  /** @format int32 */
  typeCategoryId?: number;
  /** @format int32 */
  group?: number;
  /** @format int32 */
  orderNumber?: number;
  /** @format int32 */
  addNumber?: number;
  imgUrl?: string | null;
  attributeImg?: string | null;
  zoomImgUrl?: string | null;
  productUrl?: string | null;
  configUrl?: string | null;
  wfid?: string | null;
  /** @format int32 */
  toolIdOfCreation?: number | null;
  customConfigTitle?: string | null;
  customConfigText?: string | null;
  validity?: ValidityType;
  isBest?: boolean;
  failCaseLog?: string | null;
  toolUniqueName?: string | null;
  attributes?: ComparisonAttribute[] | null;
  connections?: ConnectionResult[] | null;
}

export interface ComparisonViewModel {
  viewName?: string | null;
  attributeHeaders?: ComparisonAttributeHeaders[] | null;
  calculatedValues?: CalculatedValue[] | null;
  products?: ComparisonProduct[] | null;
  wfId?: string | null;
  compareTitle?: string | null;
  /** @format int32 */
  displayRowDefaultSize?: number;
  seriesGroupByDefault?: boolean;
  imageVisibleByDefault?: boolean;
  frlCustom?: boolean;
  hasCalculatedValues?: boolean;
  defaultSortColumn?: string | null;
  defaultSortIsAscending?: boolean;
  groupingIsVisible?: boolean;
  neverFilterColumns?: string[] | null;
  stopWorkflowatCompare?: boolean;
  toolTipText?: string | null;
  toolUniqueName?: string | null;
}

export interface ConfigurableMessage {
  title?: string | null;
  text?: string | null;
}

export enum ConfigureButtonMode {
  Off = 'Off',
  Sizing = 'Sizing',
  Recommendation = 'Recommendation',
}

export enum ConfiguredPartState {
  Placeholder = 'Placeholder',
  PartiallyConfigured = 'PartiallyConfigured',
  FullyConfigured = 'FullyConfigured',
  SomeDataEntered = 'SomeDataEntered',
  AllDataEntered = 'AllDataEntered',
}

export interface ConfigureRequest {
  /** @format uuid */
  workflowId?: string;
  /** @format int32 */
  compareIndex?: number;
  partCategoryName?: string | null;
}

export interface ConfigureResponse {
  redirectToWorkflowRouter?: boolean;
  redirectUrl?: string | null;
  configuratorType?: string | null;
}

export interface ConnectionResult {
  resultPartNumber?: string | null;
  connections?: string[] | null;
  connectionType?: string | null;
}

export interface ConvertedValve {
  /** @format uuid */
  workflowId: string;
  workflowSteps: WorkflowStepStatus[];
  /** @format int32 */
  groupInstanceId: number;
  /** @format int32 */
  row: number;
  /** @format int32 */
  column: number;
  /** @format int32 */
  order: number;
}

export interface CopyRule {
  /** @format int32 */
  sourceDefinitionId?: number;
  /** @format int32 */
  destinationDefinitionId?: number;
}

export interface CreateGroupRequest {
  /** @format uuid */
  systemId: string;
  /** @format int32 */
  definitionId: number;
  name: string;
  isFinished?: boolean;
  /** @format int32 */
  parentGroupId?: number | null;
  isLastInLine?: boolean;
}

export interface CreateGroupResponse {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  parentGroupId?: number | null;
}

export interface CreateManifoldRequest {
  manifoldGroup?: CreateGroupRequest;
  segmentGroup?: CreateGroupRequest;
  overlappingGroups?: CreateGroupRequest[] | null;
  manifold?: CreatePartRequest;
  valves?: CreatePartRequest[] | null;
  /** @format int32 */
  existingOverlappingGroupId?: number | null;
  /** @format uuid */
  existingLinkedPartId?: string | null;
}

export interface CreateManifoldResponse {
  manifoldGroup?: CreateGroupResponse;
  segmentGroup?: CreateGroupResponse;
  overlappingGroups?: CreateGroupResponse[] | null;
  manifold?: CreatePartResponse;
  valves?: CreatePartResponse[] | null;
  overlapGroupLinks?: OverlapGroupLinkResponse[] | null;
  virtualGroups?: VirtualGroup[] | null;
}

export interface CreatePartFromWorkflowRequest {
  /** @format uuid */
  systemId: string;
  /** @format uuid */
  workflowId: string;
}

export interface CreatePartLinkRequest {
  /** @format int32 */
  startChipId?: number;
  /** @format int32 */
  endChipId?: number;
  linkState?: LinkState;
}

export interface CreatePartLinkResponse {
  /** @format int32 */
  id?: number;
}

export interface CreatePartRequest {
  /** @format int32 */
  groupInstanceId?: number;
  groupIsFinished?: boolean;
  /** @format int32 */
  categoryId?: number;
  /** @format int32 */
  row?: number;
  /** @format int32 */
  column?: number;
  /** @format int32 */
  order?: number;
  name?: string | null;
}

export interface CreatePartResponse {
  /** @format uuid */
  id: string;
  /** @format uuid */
  workflowId: string;
  /** @format int32 */
  groupInstanceId: number;
  state: ConfiguredPartState;
  isParkerPart: boolean;
  sourcing: ParkerProduct;
  /** @format int32 */
  chipId: number;
  chipState: ChipState;
  metadataInstances: Metadata[];
  dataItems: DataItem[];
  workflowSteps: WorkflowStepStatus[];
}

export interface CreatePartSizingDataRequest {
  /** @format uuid */
  partId?: string;
  /** @format int32 */
  groupId?: number;
  /** @format int32 */
  templateTypeId?: number;
  isReplacementPart?: boolean;
}

export type CreatePartSizingDataResponse = object;

export interface CreateProjectRequest {
  /** @maxLength 256 */
  name: string;
  /** @maxLength 4000 */
  description?: string | null;
}

export interface CreateSystemRequest {
  /** @format uuid */
  projectId: string;
  /** @maxLength 256 */
  name: string;
  /** @format int32 */
  templateId: number;
  /** @maxLength 4000 */
  description?: string | null;
}

export interface CSCCompareDataColumn {
  key?: string | null;
  dataSource?: DataSource;
  unitGroup?: UnitGroup;
  /** @format int32 */
  metricUnitSelected?: number;
  /** @format int32 */
  imperialUnitSelected?: number;
  isString?: boolean;
  /** @format int32 */
  order?: number;
  shortName?: string | null;
  longName?: string | null;
  displayMode?: CompareDisplayMode;
  isDefaultSort?: boolean;
  sortOrder?: SortOrder;
  /** @format double */
  valueNumberImperial?: number;
  /** @format double */
  valueNumberMetric?: number;
  valueString?: string | null;
  /** @format int32 */
  minWidth?: number;
  /** @format int32 */
  maxWidth?: number;
}

export interface CSCFilterOutputData {
  extendedJSONData?: string | null;
  /** @format int32 */
  group?: number;
  /** @format int32 */
  groupOrder?: number;
  /** @format int32 */
  addOrder?: number;
  /** @format int32 */
  websphereCategoryId?: number;
  /** @format uuid */
  wfid?: string;
  /** @format int32 */
  toolIdOfCreation?: number | null;
  /** @format int32 */
  websphereSeriesId?: number;
  /** @format int32 */
  typeCategoryId?: number;
  title?: string | null;
  customConfigText?: ConfigurableMessage;
  connectionJson?: string | null;
  /** @format double */
  normalizedRelativePrice?: number | null;
  /** @format int32 */
  sortOrder?: number | null;
  selected?: boolean;
  /** @format int32 */
  compareIndex?: number;
  isValid?: boolean;
  isBest?: boolean;
  mode?: ProductMode;
  configureUrl?: string | null;
  failCaseLog?: string | null;
  productName?: string | null;
  productAttributeImg?: string | null;
  partNumber?: string | null;
  manualFilterLists?: ProductStructure;
  compareDataContainer?: CSCCompareDataColumn[] | null;
}

export interface CSCFilterOutputDataFilterResultsContainer {
  /** @format uuid */
  wfid?: string;
  /** @format int32 */
  typeCategoryId?: number;
  showGenerateResults?: boolean;
  showConfigure?: ConfigureButtonMode;
  showCompare?: boolean;
  showPrice?: boolean;
  logGenerated?: boolean;
  logEnabledInConfig?: boolean;
  rawFeedback?: string | null;
  websphereDatas?: WebsphereData[] | null;
  products?: CSCFilterOutputData[] | null;
  worstFailCases?: FailureCase[] | null;
  outputDynamicDataEntriesJson?: string | null;
  tooManyResults?: boolean;
  groupedFilterItems?: FilterResultProductWithChildren[] | null;
  compareViewModel?: ComparisonViewModel;
  failureMessage?: string | null;
  userFilteredParts?: ProductPart[] | null;
}

export interface DataItem {
  /** @format uuid */
  id?: string;
  key?: string | null;
  value?: string | null;
}

export enum DataSource {
  Input = 'Input',
  Attribute = 'Attribute',
  Calculated = 'Calculated',
}

export enum DataType {
  None = 'None',
  Int = 'Int',
  Double = 'Double',
  String = 'String',
  Bool = 'Bool',
  Image = 'Image',
  StringList = 'StringList',
}

export type DeleteGroupResponse = object;

export interface DeleteManifoldMountedValveResponse {
  updatedValvesChips: UpdatedValveChip[];
}

export type DeleteManifoldResponse = object;

export type DeletePartResponse = object;

export interface DisconnectGroupFromManifoldResponse {
  valveWasConverted: boolean;
  valveWasDeleted: boolean;
  overlappingGroupIsFinished: boolean;
  standAloneValve?: ConvertedValve;
  partLink?: PartLink;
  updatedValvesChips: UpdatedValveChip[];
}

export enum FailureCase {
  ExceededAmps = 'ExceededAmps',
  ExceededMaxPressure = 'ExceededMaxPressure',
  PressureDropTooSmall = 'PressureDropTooSmall',
  DesignPressureDrop = 'DesignPressureDrop',
  AmbientPressureDrop = 'AmbientPressureDrop',
  ExceededMaxPercentRated = 'ExceededMaxPercentRated',
  ExceededMinPercentRated = 'ExceededMinPercentRated',
  SettingPressure = 'SettingPressure',
  NozzlePercentRated = 'NozzlePercentRated',
  TubePercentRated = 'TubePercentRated',
  ExceedMaxTorque = 'ExceedMaxTorque',
  BelowMinTorqueMargin = 'BelowMinTorqueMargin',
  AboveMaxTorqueMargin = 'AboveMaxTorqueMargin',
  ExceedContTorque = 'ExceedContTorque',
  BelowContMinTorqueMargin = 'BelowContMinTorqueMargin',
  AboveContMaxTorqueMargin = 'AboveContMaxTorqueMargin',
  ExceedMaxCalcSpeed = 'ExceedMaxCalcSpeed',
  ExceedContinousPower = 'ExceedContinousPower',
  ExceedPeakPower = 'ExceedPeakPower',
  BelowMinInertiaRatio = 'BelowMinInertiaRatio',
  AboveMaxInertiaRatio = 'AboveMaxInertiaRatio',
  BacklashOutofRange = 'BacklashOutofRange',
  ExceedMaxGearSpeed = 'ExceedMaxGearSpeed',
  ExceedMaxMotorSpeed = 'ExceedMaxMotorSpeed',
  ExceedMaxContGearSpeed = 'ExceedMaxContGearSpeed',
  ExceedMaxcontMotorSpeed = 'ExceedMaxcontMotorSpeed',
  GalaxyMotorDriveVoltage = 'GalaxyMotorDriveVoltage',
  GalaxyDriveSize = 'GalaxyDriveSize',
  GalaxyMotorDriveCurrent = 'GalaxyMotorDriveCurrent',
  GalaxyMotorSize = 'GalaxyMotorSize',
  GalaxyAmplifierSwitchingVoltage = 'GalaxyAmplifierSwitchingVoltage',
  GalaxyRequiredRMSTorque = 'GalaxyRequiredRMSTorque',
  GalaxyMotorDriveFeedback = 'GalaxyMotorDriveFeedback',
  GalaxyBusVoltageToHighDrive = 'GalaxyBusVoltageToHighDrive',
  GalaxyBusVoltageToLowDrive = 'GalaxyBusVoltageToLowDrive',
  GalaxyMaximumTorqueMargin = 'GalaxyMaximumTorqueMargin',
  GalaxyAmbientTempTooLow = 'GalaxyAmbientTempTooLow',
  GalaxyAmbientTempTooHigh = 'GalaxyAmbientTempTooHigh',
  GalaxyMisMatchedMotionType = 'GalaxyMisMatchedMotionType',
  GalaxyCaseTempExceedsMaxTemp = 'GalaxyCaseTempExceedsMaxTemp',
  GalaxyWindingTempExceedsRatedTemp = 'GalaxyWindingTempExceedsRatedTemp',
  GalaxyFailureForceSpeedCurve = 'GalaxyFailureForceSpeedCurve',
  GalaxyFailureTorqueSpeedCurve = 'GalaxyFailureTorqueSpeedCurve',
  GalaxyUnknown = 'GalaxyUnknown',
  GalaxyNone = 'GalaxyNone',
}

export interface FilterItemModel {
  extendedJSONData?: string | null;
  /** @format int32 */
  group?: number;
  /** @format int32 */
  groupOrder?: number;
  /** @format int32 */
  addOrder?: number;
  /** @format int32 */
  websphereCategoryId?: number;
  /** @format uuid */
  wfid?: string;
  /** @format int32 */
  toolIdOfCreation?: number | null;
  /** @format int32 */
  websphereSeriesId?: number;
  /** @format int32 */
  typeCategoryId?: number;
  title?: string | null;
  customConfigText?: ConfigurableMessage;
  connectionJson?: string | null;
  /** @format double */
  normalizedRelativePrice?: number | null;
  /** @format int32 */
  sortOrder?: number | null;
  selected?: boolean;
  /** @format int32 */
  compareIndex?: number;
  isValid?: boolean;
  isBest?: boolean;
  mode?: ProductMode;
  configureUrl?: string | null;
  failCaseLog?: string | null;
  productName?: string | null;
  productAttributeImg?: string | null;
  partNumber?: string | null;
}

export enum FilterResultProductGroupingMode {
  AsGroupSpecifies = 'AsGroupSpecifies',
  ByMasterSeries = 'ByMasterSeries',
}

export interface FilterResultProductWithChildren {
  masterProduct?: FilterItemModel;
  groupIsValidClass?: string | null;
  children?: FilterItemModel[] | null;
  masterProductAndChildren?: FilterItemModel[] | null;
  groupingKey?: string | null;
  configureUrl?: string | null;
  groupingMode?: FilterResultProductGroupingMode;
}

export interface FilterSession {
  /** @format uuid */
  sessionToken?: string;
  /** @format date-time */
  startTime?: string;
  status?: FilterSessionStatus;
  statusName?: string | null;
  /** @format double */
  percentComplete?: number;
  /** @format int32 */
  productCount?: number;
  /** @format int32 */
  productTotal?: number;
  statusMessage?: string | null;
  errorMessage?: string | null;
  cancelRequested?: boolean;
  /** @format int32 */
  processStepNumber?: number;
  /** @format int32 */
  processStepTotal?: number;
  /** @format int32 */
  processStepNumberOffset?: number;
}

export enum FilterSessionStatus {
  Running = 'Running',
  Error = 'Error',
  Aborted = 'Aborted',
  Complete = 'Complete',
  Invalid = 'Invalid',
}

export interface GeneralCalcResult {
  success?: boolean;
  passOnFailure?: boolean;
  allNeededData?: boolean;
}

export interface GetFilterSessionResponse {
  filterSession?: FilterSession;
}

export interface GetGenericSizingResultsResponse {
  compareResultsContainer?: CSCFilterOutputDataFilterResultsContainer;
  productSeriesResults?: ProductSeriesFilterResult[] | null;
}

export interface GetGroupedPartCategoriesResponse {
  groupedPartCategories?: GroupedPartCategory[] | null;
  partAssemblies?: PartAssembly[] | null;
}

export interface GetManifoldAndValvesSizingProgressResponse {
  productCacheStatus?: ProductCacheStatus;
  savedSizingRequest?: SizeManifoldAndValvesInputs;
  results?: ProductSeriesFilterResult[] | null;
}

export interface GetMySystemsAndProjectsResponse {
  systems: SystemInfo[];
  projects: ProjectInfo[];
  sharedSystems: SharedSystemInfo[];
  sharedProjects: SharedProjectInfo[];
}

export interface GetProductCacheStatusResponse {
  productCacheStatus?: ProductCacheStatus;
}

export interface GetSupportDataResponse {
  units?: UnitDefinition[] | null;
}

export interface GetSystemResponse {
  /** @format uuid */
  id?: string;
  name?: string | null;
  description?: string | null;
  displayInMetricUnits?: boolean;
  locale?: string | null;
  isRightToLeft?: boolean;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format uuid */
  projectId?: string;
  projectName?: string | null;
  /** @format int32 */
  templateId?: number;
  templateUniqueName?: string | null;
  templateName?: string | null;
  templateMode?: TemplateMode;
  templateDashboardType?: TemplateDashboardType;
  addPartButtonText?: string | null;
  /** @format int32 */
  templateTypeId?: number;
  templateTypeUniqueId?: string | null;
  templateTypeName?: string | null;
  /** @format int32 */
  divisionId?: number;
  chatSkillGroup?: string | null;
  copyRules?: CopyRule[] | null;
  groupDefinitions?: GroupDefinition[] | null;
  groupHierarchies?: GroupHierarchy[] | null;
  groupMetadataDefinitions?: MetadataDefinition[] | null;
  groups?: Group[] | null;
  groupLinks?: GroupLink[] | null;
  partCategories?: PartCategory[] | null;
  partMetadataDefinitions?: MetadataDefinition[] | null;
  parts?: Part[] | null;
  partLinks?: PartLink[] | null;
  overlapGroupLinks?: OverlapGroupLinkResponse[] | null;
  virtualGroups?: VirtualGroup[] | null;
}

export interface Group {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  definitionId?: number;
  name?: string | null;
  isFinished?: boolean;
  isLastInLine?: boolean;
  /** @format int32 */
  parentGroupId?: number | null;
  /** @format uuid */
  superGroupMasterConfiguredPartId?: string | null;
  /** @format uuid */
  groupDataEditorWorkflowId?: string | null;
  metadataInstances?: Metadata[] | null;
  partAssemblyData?: string | null;
}

export enum GroupDataType {
  SuperGroup = 'SuperGroup',
  Full = 'Full',
  Prompted = 'Prompted',
  PsuedoFull = 'PsuedoFull',
  Manifold = 'Manifold',
  ManifoldSegment = 'ManifoldSegment',
}

export interface GroupDefinition {
  /** @format int32 */
  id?: number;
  uniqueName?: string | null;
  /** @format int32 */
  groupDataEditorPartCategoryId?: number | null;
  type?: GroupDataType;
  displayMode?: GroupDisplayMode;
  isTopLayer?: boolean;
  displayName?: string | null;
  buttonText?: string | null;
}

export enum GroupDisplayMode {
  ShowAll = 'ShowAll',
  ShowAsSingle = 'ShowAsSingle',
}

export interface GroupedPartCategory {
  group?: GroupToAdd;
  partCategories?: PartCategoryToAdd[] | null;
}

export interface GroupHierarchy {
  /** @format int32 */
  parentGroupDefinitionId?: number;
  /** @format int32 */
  childGroupDefinitionId?: number;
}

export interface GroupLink {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  startId?: number;
  /** @format int32 */
  endId?: number;
  state?: LinkState;
}

export interface GroupToAdd {
  /** @format int32 */
  groupDefinitionId?: number;
  isLastGroupInLine?: boolean;
}

export enum LinkState {
  Good = 'Good',
  Bad = 'Bad',
  Incomplete = 'Incomplete',
  Initial = 'Initial',
}

export interface Metadata {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  definitionId?: number;
  value?: string | null;
  /** @format int32 */
  selectedUnit?: number;
  /** @format int32 */
  origin?: number;
  originalSetter?: string | null;
  isEditable?: boolean;
  isDisabled?: boolean;
}

export interface MetadataDefinition {
  /** @format int32 */
  id?: number;
  key?: string | null;
  displayName?: string | null;
  unitGroup?: UnitGroup;
  /** @format int32 */
  unitSubGroup?: number;
  defaultValue?: string | null;
  /** @format int32 */
  defaultUnitSelected?: number;
  isEditable?: boolean;
  isRequired?: boolean;
  displayOnRightPane?: boolean;
  displayOnPartCard?: boolean;
  displayOnSummary?: boolean;
  displayOnDashboard?: boolean;
  dataType?: DataType;
  dataSource?: DataSource;
  setOnDashboard?: boolean;
  function?: AggregateFunction;
  isEditableUnit?: boolean;
}

export interface Option {
  /** @format int32 */
  id?: number;
  areaImageUrl?: string | null;
  silhouetteUrl?: string | null;
  optionUrl?: string | null;
  partMetadataValue?: string | null;
  addOnDashboard?: boolean;
  partMetadataDefinitionKey?: string | null;
  displayName?: string | null;
  displayShortName?: string | null;
  description?: string | null;
}

export interface OverlapGroupLinkResponse {
  /** @format int32 */
  id: number;
  /** @format int32 */
  overlappingGroupId: number;
  /** @format int32 */
  intersectedGroupId: number;
  /** @format uuid */
  linkedPartId?: string | null;
  /** @format uuid */
  intersectedPartId: string;
  /** @format int32 */
  linkOrder: number;
  linkState: LinkState;
  linkData?: string | null;
}

export enum ParkerProduct {
  ParkerOnly = 'ParkerOnly',
  NonParkerOnly = 'NonParkerOnly',
  Choice = 'Choice',
  Placeholder = 'Placeholder',
}

export interface Part {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  workflowId?: string;
  /** @format int32 */
  categoryId?: number;
  /** @format int32 */
  groupInstanceId?: number;
  state?: ConfiguredPartState;
  isParkerPart?: boolean;
  sourcing?: ParkerProduct;
  /** @format int32 */
  chipId?: number;
  chipState?: ChipState;
  /** @format int32 */
  row?: number;
  /** @format int32 */
  column?: number;
  /** @format int32 */
  order?: number;
  name?: string | null;
  metadataInstances?: Metadata[] | null;
  dataItems?: DataItem[] | null;
  workflowSteps?: WorkflowStepStatus[] | null;
  seriesId?: string | null;
  seriesCode?: string | null;
  seriesVariableName?: string | null;
  shortDescription?: string | null;
  thumbnail?: string | null;
  isInactive?: boolean;
  recommendedAlternativePart?: string | null;
}

export interface PartAssembly {
  code?: string | null;
  isLastInLine?: boolean;
}

export interface PartCategory {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  divisionId?: number;
  name?: string | null;
  /** @format int32 */
  minNumberOfInputs?: number;
  /** @format int32 */
  minNumberOfOutputs?: number;
  /** @format int32 */
  maxNumberOfInputs?: number;
  /** @format int32 */
  maxNumberOfOutputs?: number;
  sourcing?: ParkerProduct;
  isFullSizing?: boolean;
  options?: Option[] | null;
}

export interface PartCategoryToAdd {
  /** @format int32 */
  partCategoryId?: number;
  isLastPartInGroup?: boolean;
}

export interface PartInfo {
  name: string;
  number: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface PartLink {
  /** @format int32 */
  id?: number;
  /** @format uuid */
  startId?: string;
  /** @format uuid */
  endId?: string;
  /** @format int32 */
  startChipId?: number;
  /** @format int32 */
  startChipRow?: number;
  /** @format int32 */
  startChipColumn?: number;
  /** @format int32 */
  endChipId?: number;
  /** @format int32 */
  endChipRow?: number;
  /** @format int32 */
  endChipColumn?: number;
  state?: LinkState;
}

export interface ProductArea {
  name?: string | null;
  image?: string | null;
  /** @format int32 */
  typeCatId?: number;
  children?: Series[] | null;
}

export enum ProductCacheStatus {
  Unpopulated = 'Unpopulated',
  Populating = 'Populating',
  Populated = 'Populated',
  Error = 'Error',
}

export enum ProductMode {
  Normal = 'Normal',
  Forced = 'Forced',
  OutOfStock = 'OutOfStock',
}

export interface ProductPart {
  partNumber?: string | null;
  name?: string | null;
  image?: string | null;
  distinctName?: string | null;
  /** @format int32 */
  typeCatId?: number;
  /** @format int32 */
  seriesId?: number;
  seriesName?: string | null;
}

export interface ProductSeriesFilterResult {
  /** @format int32 */
  productResultsCount?: number;
  /** @format int32 */
  seriesId?: number;
  seriesName?: string | null;
  seriesShortDescription?: string | null;
  seriesThumbnailUrl?: string | null;
  seriesProductInfoUrl?: string | null;
}

export interface ProductStructure {
  areas?: ProductArea[] | null;
  selectedParts?: ProductPart[] | null;
  renderOnClient?: boolean;
}

export interface ProjectInfo {
  /** @format uuid */
  id: string;
  name: string;
  description?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface RevertManifoldRequest {
  /** @format int32 */
  manifoldGroupId: number;
}

export type RevertManifoldResponse = object;

export interface SaveManifoldAndValvesSizingProgressRequest {
  /** @format uuid */
  workflowId?: string;
  inputs?: SizeManifoldAndValvesInputs;
}

export type SaveManifoldAndValvesSizingProgressResponse = object;

export interface SaveProjectSharesRequest {
  /** @format uuid */
  projectId: string;
  newShares: SystemShareInfo[];
  updatedShares: SystemShareInfo[];
  deletedShareIds: number[];
  /** @minLength 1 */
  userFullName: string;
  message?: string | null;
}

export interface SaveSystemSharesRequest {
  /** @format uuid */
  systemId: string;
  newShares: SystemShareInfo[];
  updatedShares: SystemShareInfo[];
  deletedShareIds: number[];
  /** @minLength 1 */
  userFullName: string;
  message?: string | null;
}

export interface SaveSystemSharesResponse {
  /** @format int32 */
  newSharesCount: number;
  /** @format int32 */
  updatedSharesCount: number;
  /** @format int32 */
  deletedSharesCount: number;
}

export interface Series {
  name?: string | null;
  image?: string | null;
  /** @format int32 */
  websphereId?: number;
  children?: ProductPart[] | null;
}

export interface SharedProjectInfo {
  /** @format uuid */
  id: string;
  name: string;
  description?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string | null;
  owner: string;
  ownerEmail: string;
}

export interface SharedSystemInfo {
  /** @format uuid */
  id: string;
  name: string;
  description?: string | null;
  systemTypeName: string;
  templateName: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string | null;
  projectName: string;
  /** @format uuid */
  projectId: string;
  parts: PartInfo[];
  owner: string;
  ownerEmail: string;
}

export interface SizeManifoldAndValvesInputs {
  valveOperatorVoltage?: string | null;
  electricalConnectionToManifold?: string | null;
  electricalConnectionCategory?: string | null;
  electricalConnectionType?: string | null;
  portType?: string | null;
  /** @format double */
  minTemperature?: number | null;
  minTemperatureUnit?: TemperatureUnits;
  /** @format double */
  maxTemperature?: number | null;
  maxTemperatureUnit?: TemperatureUnits;
  /** @format double */
  maxAirflow?: number | null;
  maxAirflowUnit?: VolumetricFlowRateUnits;
  isFlowCalculated?: boolean;
  /** @format double */
  maxCv?: number | null;
  valveSequencingCycles?: ValveSequencingCycle[] | null;
  valveInputs?: SizeValveOnManifoldRequest[] | null;
}

export interface SizeManifoldAndValvesRequest {
  /** @format uuid */
  workflowId?: string;
  /** @format int32 */
  partCategoryId?: number;
  partCategoryName?: string | null;
  locale?: string | null;
  /** @format int32 */
  divisionId?: number;
  loggingEnabled?: boolean;
  skipMicroFilter?: boolean;
  filterProductOverride?: string | null;
  inputs?: SizeManifoldAndValvesInputs;
  overlapGroupLinkIds?: number[] | null;
  /** @format int32 */
  manifoldGroupId?: number;
  /** @format int32 */
  startRow?: number;
}

export type SizeManifoldAndValvesResponse = object;

export interface SizeValveOnManifoldRequest {
  /** @format uuid */
  partId?: string;
  valveFunction?: string | null;
  operatorType?: string | null;
  useRegulator?: boolean;
}

export interface SizingNotification {
  /** @format uuid */
  systemId?: string;
  /** @format uuid */
  workflowId?: string;
  closeTabs?: boolean;
}

export enum SortOrder {
  Ascending = 'ascending',
  Descending = 'descending',
  None = 'none',
}

export interface SystemInfo {
  /** @format uuid */
  id: string;
  name: string;
  description?: string | null;
  systemTypeName: string;
  templateName: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string | null;
  projectName: string;
  /** @format uuid */
  projectId: string;
  parts: PartInfo[];
}

export interface SystemShareInfo {
  /** @format int32 */
  id: number;
  /** @format uuid */
  systemId?: string | null;
  email: string;
  status: SystemShareStatus;
  isEditable: boolean;
  /** @format uuid */
  projectId?: string | null;
  shareReason: SystemShareReason;
}

export enum SystemShareReason {
  Help = 'Help',
  Collaboration = 'Collaboration',
  Quote = 'Quote',
  Distributor = 'Distributor',
}

export enum SystemShareStatus {
  Initiated = 'Initiated',
  Pending = 'Pending',
  Complete = 'Complete',
}

export interface SystemType {
  /** @format int32 */
  id: number;
  uniqueId: string;
  name: string;
  templates: TemplateInfo[];
}

export enum TemperatureUnits {
  Fahrenheit = 'Fahrenheit',
  Celcius = 'Celcius',
  Kelvin = 'Kelvin',
  Rankine = 'Rankine',
}

export enum TemplateDashboardType {
  Basic = 'Basic',
  SporlanThermo = 'SporlanThermo',
  ControllerFirst = 'ControllerFirst',
  ActuatorFirst = 'ActuatorFirst',
  Manifold = 'Manifold',
  ComplexMotion = 'ComplexMotion',
  SystemFirst = 'SystemFirst',
  ActuatorAndSystemFirst = 'ActuatorAndSystemFirst',
}

export interface TemplateInfo {
  /** @format int32 */
  id: number;
  uniqueName: string;
  name: string;
  description?: string | null;
}

export enum TemplateMode {
  Full = 'Full',
  Prompted = 'Prompted',
  PsuedoFull = 'PsuedoFull',
}

export interface UnitDefinition {
  unitGroup?: string | null;
  /** @format int32 */
  unitSubgroup?: number;
  /** @format int32 */
  unit?: number;
  unitLabel?: string | null;
  unitName?: string | null;
  isDefaultForMetric?: boolean;
  isDefaultForImperial?: boolean;
}

export enum UnitGroup {
  None = 'None',
  Mass = 'Mass',
  Current = 'Current',
  Temperature = 'Temperature',
  Volume = 'Volume',
  VolumetricFlowRate = 'VolumetricFlowRate',
  Time = 'Time',
  Acceleration = 'Acceleration',
  Angle = 'Angle',
  Velocity = 'Velocity',
  RotationalVelocity = 'RotationalVelocity',
  Distance = 'Distance',
  Pressure = 'Pressure',
  Force = 'Force',
  Weight = 'Weight',
  Torque = 'Torque',
  Inertia = 'Inertia',
  Energy = 'Energy',
  Power = 'Power',
  Voltage = 'Voltage',
  VolumeCycle = 'VolumeCycle',
  Frequency = 'Frequency',
  Area = 'Area',
  Percent = 'Percent',
  Density = 'Density',
  Capacity = 'Capacity',
  Viscosity = 'Viscosity',
  VolumePerWeigth = 'VolumePerWeigth',
  Enthalpy = 'Enthalpy',
  Entropy = 'Entropy',
  RotationalAcceleration = 'RotationalAcceleration',
  Pitch = 'Pitch',
  FlowRate = 'FlowRate',
  TemperatureDelta = 'TemperatureDelta',
  Currency = 'Currency',
}

export interface UpdateCalculatedMetadataBatchRequest {
  /** @minItems 1 */
  partIds: string[];
}

export interface UpdateCalculatedMetadataBatchResponse {
  results: UpdateCalculatedMetadataResponse[];
}

export interface UpdateCalculatedMetadataResponse {
  calculationResult: GeneralCalcResult;
  metadataInstances: Metadata[];
  /** @format uuid */
  partId: string;
}

export interface UpdatedValveChip {
  /** @format int32 */
  id: number;
  /** @format int32 */
  row: number;
  /** @format int32 */
  order: number;
}

export interface UpdateGroupRequest {
  /** @format int32 */
  groupId?: number;
  name?: string | null;
  isFinished?: boolean;
}

export type UpdateGroupResponse = object;

export interface UpdateOverlapGroupLinkRequest {
  /** @format int32 */
  id: number;
  /** @format uuid */
  linkedPartId?: string | null;
  linkState: LinkState;
}

export interface UpdateOverlapGroupLinkResponse {
  virtualGroup: VirtualGroup;
}

export interface UpdatePartRequest {
  /** @format uuid */
  partId?: string;
  name?: string | null;
  /** @format int32 */
  groupInstanceId?: number;
  /** @format int32 */
  order?: number;
  metadataInstances?: Metadata[] | null;
}

export type UpdatePartResponse = object;

export interface UpdateProjectRequest {
  /** @format uuid */
  projectId: string;
  /** @maxLength 256 */
  name: string;
  /** @maxLength 4000 */
  description?: string | null;
  isDeleted: boolean;
}

export interface UpdateProjectResponse {
  updated: boolean;
  name: string;
  deleted: boolean;
}

export interface UpdateSystemRequest {
  /** @format uuid */
  id: string;
  name?: string | null;
  description?: string | null;
  displayInMetricUnits?: boolean;
  isRightToLeft?: boolean;
  isDeleted?: boolean;
}

export interface UpdateSystemResponse {
  updated?: boolean;
  name?: string | null;
  deleted?: boolean;
}

export interface UpdateWorkflowRequest {
  /** @format uuid */
  id?: string;
  /** @format int32 */
  stepId?: number;
}

export type UpdateWorkflowResponse = object;

export enum ValidityType {
  Normal = 'Normal',
  Valid = 'Valid',
  Invalid = 'Invalid',
}

export interface ValveSequencingApplication {
  enabled?: boolean;
  /** @format int32 */
  id?: number;
  name?: string | null;
  /** @format double */
  airflow?: number;
  /** @format double */
  cv?: number;
}

export interface ValveSequencingCycle {
  /** @format int32 */
  cycleId?: number;
  applications?: ValveSequencingApplication[] | null;
  /** @format int32 */
  derated?: number;
}

export interface VirtualGroup {
  /** @format int32 */
  baseGroupId: number;
  /** @format int32 */
  intersectedGroupId: number;
  linkedPartIds?: string[] | null;
  /** @format uuid */
  intersectedPartId: string;
  overlapGroupLinkIds: number[];
}

export enum VolumetricFlowRateUnits {
  CubicMeterPerSecond = 'CubicMeterPerSecond',
  CubicFootPerSecond = 'CubicFootPerSecond',
  CubicInchPerSecond = 'CubicInchPerSecond',
  StandardCubicFtPerMinute = 'StandardCubicFtPerMinute',
  DecimeterCubedPerSecond = 'DecimeterCubedPerSecond',
  LitersPerMinute = 'LitersPerMinute',
}

export interface WebsphereData {
  /** @format int32 */
  websphereSeriesId?: number;
  websphereName?: string | null;
  imageUrl?: string | null;
  zoomImageUrl?: string | null;
  productUrl?: string | null;
  cadUrl?: string | null;
  description?: string | null;
}

export interface WorkflowStepStatus {
  /** @format int32 */
  id?: number;
  name?: string | null;
  isCompleted?: boolean;
}

// Due to a bug in the generator (https://github.com/acacode/swagger-typescript-api/issues/331)
// trying to import type HeadersDefaults results in an error: TS2614: Module '"axios"' has no exported member 'HeadersDefaults'
// It is safe to delete all instances of HeadersDefaults
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (securityData: SecurityDataType | null) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  // It is safe to delete all instances of type HeadersDefaults
  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({ secure, path, type, query, format, body, ...params }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) && this.securityWorker && (await this.securityWorker(this.securityData))) || {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Virtual Engineer API
 * @version v1
 *
 * A Web API for managing Parker's Virtual Engineer dashboard and sizing tools
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags GroupedPartCategories
     * @name GroupedPartCategoriesList
     * @request GET:/api/GroupedPartCategories
     */
    groupedPartCategoriesList: (
      query: {
        /** @format int32 */
        TemplateTypeId: number;
        /** @format int32 */
        PreviousPartCategoryId?: number;
        /** @format int32 */
        GroupDefinitionId?: number;
        PreviousPartCategoryName?: string;
        PreviousGroupDefinitionUniqueName?: string;
        CurrentGroupDefinitionUniqueName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetGroupedPartCategoriesResponse, void>({
        path: `/api/GroupedPartCategories`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name GroupsCreate
     * @request POST:/api/Groups
     * @secure
     */
    groupsCreate: (data: CreateGroupRequest, params: RequestParams = {}) =>
      this.request<CreateGroupResponse, void>({
        path: `/api/Groups`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name GroupsUpdate
     * @request PUT:/api/Groups/{id}
     * @secure
     */
    groupsUpdate: (id: number, data: UpdateGroupRequest, params: RequestParams = {}) =>
      this.request<UpdateGroupResponse, void>({
        path: `/api/Groups/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name GroupsDelete
     * @request DELETE:/api/Groups/{id}
     * @secure
     */
    groupsDelete: (id: number, params: RequestParams = {}) =>
      this.request<DeleteGroupResponse, void>({
        path: `/api/Groups/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name GroupsDetail
     * @request GET:/api/Groups/{id}
     * @secure
     */
    groupsDetail: (id: number, params: RequestParams = {}) =>
      this.request<Group, void>({
        path: `/api/Groups/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Manifolds
     * @name ManifoldsCreate
     * @request POST:/api/Manifolds
     * @secure
     */
    manifoldsCreate: (data: CreateManifoldRequest, params: RequestParams = {}) =>
      this.request<CreateManifoldResponse, void>({
        path: `/api/Manifolds`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Manifolds
     * @name ManifoldsFakesDetail
     * @request GET:/api/Manifolds/Fakes/{name}
     * @secure
     */
    manifoldsFakesDetail: (name: string, params: RequestParams = {}) =>
      this.request<GetSystemResponse, void>({
        path: `/api/Manifolds/Fakes/${name}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Manifolds
     * @name RevertOptimization
     * @request PUT:/api/Manifolds/{id}/Reverted
     * @secure
     */
    revertOptimization: (id: string, data: RevertManifoldRequest, params: RequestParams = {}) =>
      this.request<RevertManifoldResponse, void>({
        path: `/api/Manifolds/${id}/Reverted`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Manifolds
     * @name AddValveToManifold
     * @request POST:/api/Manifolds/{id}/Valves
     * @secure
     */
    addValveToManifold: (id: number, data: AddValveToManifoldRequest, params: RequestParams = {}) =>
      this.request<AddValveToManifoldResponse, void>({
        path: `/api/Manifolds/${id}/Valves`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Manifolds
     * @name DeleteValveFromManifold
     * @request DELETE:/api/Manifolds/{manifoldId}/Valves/{valveId}
     * @secure
     */
    deleteValveFromManifold: (manifoldId: number, valveId: string, params: RequestParams = {}) =>
      this.request<DeleteManifoldMountedValveResponse, void>({
        path: `/api/Manifolds/${manifoldId}/Valves/${valveId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Manifolds
     * @name DisconnectGroupFromManifold
     * @request DELETE:/api/Manifolds/{manifoldId}/OverlappingGroups/{overlappingGroupId}
     * @secure
     */
    disconnectGroupFromManifold: (manifoldId: number, overlappingGroupId: number, params: RequestParams = {}) =>
      this.request<DisconnectGroupFromManifoldResponse, void>({
        path: `/api/Manifolds/${manifoldId}/OverlappingGroups/${overlappingGroupId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Manifolds
     * @name ManifoldsDelete
     * @request DELETE:/api/Manifolds/{id}
     * @secure
     */
    manifoldsDelete: (
      id: number,
      query?: {
        /** @default false */
        includeOverlappingGroups?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeleteManifoldResponse, void>({
        path: `/api/Manifolds/${id}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OverlapGroupLinks
     * @name OverlapGroupLinksUpdate
     * @request PUT:/api/OverlapGroupLinks/{id}
     * @secure
     */
    overlapGroupLinksUpdate: (id: number, data: UpdateOverlapGroupLinkRequest, params: RequestParams = {}) =>
      this.request<UpdateOverlapGroupLinkResponse, void>({
        path: `/api/OverlapGroupLinks/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartLinks
     * @name PartLinksCreate
     * @request POST:/api/PartLinks
     * @secure
     */
    partLinksCreate: (data: CreatePartLinkRequest, params: RequestParams = {}) =>
      this.request<CreatePartLinkResponse, void>({
        path: `/api/PartLinks`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartLinks
     * @name PartLinksDetail
     * @request GET:/api/PartLinks/{id}
     * @secure
     */
    partLinksDetail: (id: number, params: RequestParams = {}) =>
      this.request<PartLink, void>({
        path: `/api/PartLinks/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name PartsDetail
     * @request GET:/api/Parts/{id}
     * @secure
     */
    partsDetail: (id: string, params: RequestParams = {}) =>
      this.request<Part, void>({
        path: `/api/Parts/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name PartsUpdate
     * @request PUT:/api/Parts/{id}
     * @secure
     */
    partsUpdate: (id: string, data: UpdatePartRequest, params: RequestParams = {}) =>
      this.request<UpdatePartResponse, void>({
        path: `/api/Parts/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name PartsDelete
     * @request DELETE:/api/Parts/{id}
     * @secure
     */
    partsDelete: (id: string, params: RequestParams = {}) =>
      this.request<DeletePartResponse, void>({
        path: `/api/Parts/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name PartsSizingNotificationCreate
     * @request POST:/api/Parts/{partId}/SizingNotification
     */
    partsSizingNotificationCreate: (partId: string, data: SizingNotification, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Parts/${partId}/SizingNotification`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name PartsReturnToSizingNotificationCreate
     * @request POST:/api/Parts/{partId}/ReturnToSizingNotification
     */
    partsReturnToSizingNotificationCreate: (partId: string, data: SizingNotification, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Parts/${partId}/ReturnToSizingNotification`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name PartsCreate
     * @request POST:/api/Parts
     * @secure
     */
    partsCreate: (data: CreatePartRequest, params: RequestParams = {}) =>
      this.request<CreatePartResponse, void>({
        path: `/api/Parts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name PartsSizingDataCreate
     * @request POST:/api/Parts/{id}/SizingData
     */
    partsSizingDataCreate: (id: string, data: CreatePartSizingDataRequest, params: RequestParams = {}) =>
      this.request<CreatePartSizingDataResponse, void>({
        path: `/api/Parts/${id}/SizingData`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name PartsUpdateCalculatedMetadataCreate
     * @request POST:/api/Parts/{id}/UpdateCalculatedMetadata
     */
    partsUpdateCalculatedMetadataCreate: (id: string, params: RequestParams = {}) =>
      this.request<UpdateCalculatedMetadataResponse, void>({
        path: `/api/Parts/${id}/UpdateCalculatedMetadata`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name PartsBatchUpdateCalculatedMetadataUpdate
     * @request PUT:/api/Parts/BatchUpdateCalculatedMetadata
     */
    partsBatchUpdateCalculatedMetadataUpdate: (data: UpdateCalculatedMetadataBatchRequest, params: RequestParams = {}) =>
      this.request<UpdateCalculatedMetadataBatchResponse, void>({
        path: `/api/Parts/BatchUpdateCalculatedMetadata`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsCreate
     * @request POST:/api/Projects
     * @secure
     */
    projectsCreate: (data: CreateProjectRequest, params: RequestParams = {}) =>
      this.request<ProjectInfo, void>({
        path: `/api/Projects`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsUpdate
     * @request PUT:/api/Projects/{id}
     * @secure
     */
    projectsUpdate: (id: string, data: UpdateProjectRequest, params: RequestParams = {}) =>
      this.request<UpdateProjectResponse, void>({
        path: `/api/Projects/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name GetProjectShares
     * @request GET:/api/Projects/{projectId}/Shares
     * @secure
     */
    getProjectShares: (projectId: string, params: RequestParams = {}) =>
      this.request<SystemShareInfo[], void>({
        path: `/api/Projects/${projectId}/Shares`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name SaveProjectShares
     * @request PATCH:/api/Projects/{projectId}/Shares
     * @secure
     */
    saveProjectShares: (projectId: string, data: SaveProjectSharesRequest, params: RequestParams = {}) =>
      this.request<SaveSystemSharesResponse, void>({
        path: `/api/Projects/${projectId}/Shares`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sizing
     * @name SizingManifoldAndValvesProgressDetail
     * @request GET:/api/Sizing/ManifoldAndValves/{workflowId}/Progress
     */
    sizingManifoldAndValvesProgressDetail: (workflowId: string, params: RequestParams = {}) =>
      this.request<GetManifoldAndValvesSizingProgressResponse, any>({
        path: `/api/Sizing/ManifoldAndValves/${workflowId}/Progress`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sizing
     * @name SizingManifoldAndValvesProgressCreate
     * @request POST:/api/Sizing/ManifoldAndValves/{workflowId}/Progress
     */
    sizingManifoldAndValvesProgressCreate: (workflowId: string, data: SaveManifoldAndValvesSizingProgressRequest, params: RequestParams = {}) =>
      this.request<SaveManifoldAndValvesSizingProgressResponse, any>({
        path: `/api/Sizing/ManifoldAndValves/${workflowId}/Progress`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sizing
     * @name SizingProductCacheStatusList
     * @request GET:/api/Sizing/ProductCacheStatus
     */
    sizingProductCacheStatusList: (params: RequestParams = {}) =>
      this.request<GetProductCacheStatusResponse, any>({
        path: `/api/Sizing/ProductCacheStatus`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sizing
     * @name SizingManifoldAndValvesCreate
     * @request POST:/api/Sizing/ManifoldAndValves
     */
    sizingManifoldAndValvesCreate: (data: SizeManifoldAndValvesRequest, params: RequestParams = {}) =>
      this.request<SizeManifoldAndValvesResponse, any>({
        path: `/api/Sizing/ManifoldAndValves`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sizing
     * @name SizingFilterSessionDetail
     * @request GET:/api/Sizing/FilterSession/{workflowId}
     */
    sizingFilterSessionDetail: (workflowId: string, params: RequestParams = {}) =>
      this.request<GetFilterSessionResponse, any>({
        path: `/api/Sizing/FilterSession/${workflowId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sizing
     * @name SizingGenericResultsDetail
     * @request GET:/api/Sizing/GenericResults/{workflowId}
     */
    sizingGenericResultsDetail: (workflowId: string, params: RequestParams = {}) =>
      this.request<GetGenericSizingResultsResponse, any>({
        path: `/api/Sizing/GenericResults/${workflowId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sizing
     * @name SizingConfigureCreate
     * @request POST:/api/Sizing/Configure
     */
    sizingConfigureCreate: (data: ConfigureRequest, params: RequestParams = {}) =>
      this.request<ConfigureResponse, any>({
        path: `/api/Sizing/Configure`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportData
     * @name SupportDataList
     * @request GET:/api/SupportData
     */
    supportDataList: (params: RequestParams = {}) =>
      this.request<GetSupportDataResponse, any>({
        path: `/api/SupportData`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportData
     * @name SupportDataUnitConversionFunctionsList
     * @request GET:/api/SupportData/UnitConversionFunctions
     */
    supportDataUnitConversionFunctionsList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/SupportData/UnitConversionFunctions`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Systems
     * @name SystemsDetail
     * @request GET:/api/Systems/{id}
     * @secure
     */
    systemsDetail: (id: string, params: RequestParams = {}) =>
      this.request<GetSystemResponse, void>({
        path: `/api/Systems/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Systems
     * @name SystemsUpdate
     * @request PUT:/api/Systems/{id}
     * @secure
     */
    systemsUpdate: (id: string, data: UpdateSystemRequest, params: RequestParams = {}) =>
      this.request<UpdateSystemResponse, void>({
        path: `/api/Systems/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Systems
     * @name MySystemsAndProjects
     * @request GET:/api/Systems/MySystemsAndProjects
     * @secure
     */
    mySystemsAndProjects: (params: RequestParams = {}) =>
      this.request<GetMySystemsAndProjectsResponse, void>({
        path: `/api/Systems/MySystemsAndProjects`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Systems
     * @name SystemsCreate
     * @request POST:/api/Systems
     * @secure
     */
    systemsCreate: (data: CreateSystemRequest, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/Systems`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Systems
     * @name SystemTypesAndTemplates
     * @request GET:/api/Systems/TypesAndTemplates
     * @secure
     */
    systemTypesAndTemplates: (params: RequestParams = {}) =>
      this.request<SystemType[], void>({
        path: `/api/Systems/TypesAndTemplates`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Systems
     * @name CreatePartFromWorkflow
     * @request POST:/api/Systems/{systemId}/PartsFromWorkflow
     * @secure
     */
    createPartFromWorkflow: (systemId: string, data: CreatePartFromWorkflowRequest, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/Systems/${systemId}/PartsFromWorkflow`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Systems
     * @name GetSystemShares
     * @request GET:/api/Systems/{systemId}/Shares
     * @secure
     */
    getSystemShares: (systemId: string, params: RequestParams = {}) =>
      this.request<SystemShareInfo[], void>({
        path: `/api/Systems/${systemId}/Shares`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Systems
     * @name SaveSystemShares
     * @request PATCH:/api/Systems/{systemId}/Shares
     * @secure
     */
    saveSystemShares: (systemId: string, data: SaveSystemSharesRequest, params: RequestParams = {}) =>
      this.request<SaveSystemSharesResponse, void>({
        path: `/api/Systems/${systemId}/Shares`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workflow
     * @name WorkflowUpdate
     * @request PUT:/api/Workflow/{id}
     * @secure
     */
    workflowUpdate: (id: string, data: UpdateWorkflowRequest, params: RequestParams = {}) =>
      this.request<UpdateWorkflowResponse, void>({
        path: `/api/Workflow/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
}
